import { Location } from "history";
import React from "react";
import cookie from "react-cookies";

/**
 * Sets a cookie named "clickId" with the value of the "clickid"
 * query parameter from the current URL.
 * Used when site is loaded via an affiliate link.
 * EG: https://www.3etpp.com/?offer=1&clickid=018d8d61-b081-715f-bb0f-6f0606cadc35
 * @param {Location} location - The location object from React Router, containing the current URL information.
 */
const useSetAffiliateDetailsInCookie = (location: Location) => {
  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const clickid = queryParams.get("clickid");
    const pubid = queryParams.get("pubid");

    if (clickid) {
      cookie.save("clickId", clickid, {
        path: "/",
      });
      // For now will always be TRAFFIC_MANAGER, but in future will be others as well
      cookie.save("affiliateType", "TRAFFIC_MANAGER", {
        path: "/",
      });
    }
    if (pubid) {
      cookie.save("tmId", pubid, {
        path: "/",
      });
    }
  }, [location]);
};

export default useSetAffiliateDetailsInCookie;
